// extracted by mini-css-extract-plugin
module.exports = {"page":"river-3-portable-power-station_page__k0VJ3"};